import { createFileRoute } from "@tanstack/react-router"

import { DocumentsStep } from "@/features/membership/application/components/documents-step"

export const Route = createFileRoute("/membership/apply/documents")({
  component: DocumentsStep,
})
